import { render, staticRenderFns } from "./request-quote-list.vue?vue&type=template&id=58ba5de0&"
import script from "./request-quote-list.vue?vue&type=script&lang=js&"
export * from "./request-quote-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports